<template>
    <div class="offer-item-container m-0 m-md-2 mb-2 mb-md-3">
      <b-row class="mb-3 mx-0">
        <b-col sm="4" class="mt-3 mt-sm-0">
          <b-row class="h-100">
            <b-col cols="12" lg="12">
              <div class="d-flex align-items-center h-100 clickable">
                <span class="font_size_1125rem font-weight-bold">
                  <!-- <a :href="`#/recruiter/edit-job-offer/${jobOffer.id}`">{{ jobOffer.company_name }}</a> -->
                  <a @click="goToDashborad(jobOffer.id)">{{ jobOffer.company_name }}</a>
                </span>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="3" class="">
            <span class="font_size_1125rem">{{ jobOffer.payment_success_date ? `Purchased: ${purchasedDate}` : ''}}</span>
        </b-col>
        <b-col sm="3" class="">
            <span class="font_size_1125rem">{{ expiredDate ? `Expires: ${expiredDate}` : ''}}</span>
        </b-col>
        <b-col sm="2" class="">
            <span class="font_size_1125rem">${{ jobOfferPrice }}</span>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  import { JOB_OFFER_STATUSES } from '@/store';
  import { capitalize } from '@/helpers/commonHelper';
  
  export default {
    name: 'RecruiterJobOffersHistoryItem',
    props: {
      jobOffer: {
        validator: (prop) => typeof prop === 'object' || prop === null,
        default: null,
      },
    },
    computed: {
      JOB_OFFERS_STATUSES: function () {
        return JOB_OFFER_STATUSES;
      },
      expiredDate: function () {
        let paymentSuccessDate = this.jobOffer.payment_success_date;
        const paymentDate = (paymentSuccessDate) ? new Date(this.jobOffer.payment_success_date) : '';
        let offerDuration = this.jobOffer.job_offer_duration;
        const offerDays = (offerDuration) ? offerDuration : 0;
        (paymentDate) ? paymentDate.setDate(paymentDate.getDate() + offerDays) : '';
        return paymentDate ? `${this.$dayjs(paymentDate).format('MM/DD/YYYY')}` : '';
      },
      purchasedDate: function () {
        const paymentDate = (this.jobOffer.payment_success_date) ? new Date(this.jobOffer.payment_success_date) : '';
        (paymentDate) ? paymentDate.setDate(paymentDate.getDate()) : '';
        return paymentDate ? `${this.$dayjs(paymentDate).format('MM/DD/YYYY')}` : '';
      },
      jobOfferPrice: function () {
        return this.convertToInteger(this.jobOffer.job_offer_price);
      }
    },
    methods: {
      capitalize: function (string) {
        return capitalize(string);
      },
      formattedValue: function (value) {
        const nf = new Intl.NumberFormat('en-US');
        return nf.format(value);
      },
      valueWithPrefixAndSuffix: function (value) {
        return `${this.formattedValue(value)}`;
      },
      convertToInteger(decimal) {
        return parseInt(decimal, 10);
      },
      goToDashborad(jobOfferId){
        this.$router.push('/recruiter');
        this.$store.state.goToJoID = jobOfferId;
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import '../../../../sass/v3.scss';
  
  .offer-item-container {
    border-radius: 0;
    border-bottom: 1px solid $v3_color_teal;
  }
  .offer-item-container a{
    color:black !important;
  }
  .offer-item-container span{
    font-size: 1.125rem;
  }
  .border_primary_teal {
    border: 1px solid $v3_color_teal;
  }
  .edit-button {
    height: 40px;
    width: 120px;
  }
  .clickable{
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    .offer-item-container span{
      font-size: 1rem;
    }
    .offer-item-container .col-sm-4, .offer-item-container .col-sm-3, .offer-item-container .col-sm-2{
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  
  </style>
  